import { getData, postData, deleteRequest } from './api';
import {
  GmailAccount,
  GmailAccountListResponse,
  ConnectGmailResponse,
  SkippedEmailListResponse,
  TagSkippedEmailSenderResponse,
} from '../types/gmail';

export async function getGmailAccounts(): Promise<GmailAccount[]> {
  return (await getData<GmailAccountListResponse>('/api/gmail/accounts')).accounts;
}

export async function connectGmailAccount(): Promise<string> {
  return (await postData<ConnectGmailResponse>('/api/gmail/accounts/connect')).authUrl;
}

export function activateGmailAccount(accountId: string): Promise<GmailAccount> {
  return postData<GmailAccount>(`/api/gmail/accounts/${accountId}/activate`);
}

export function deactivateGmailAccount(accountId: string): Promise<GmailAccount> {
  return postData<GmailAccount>(`/api/gmail/accounts/${accountId}/deactivate`);
}

export function disconnectGmailAccount(accountId: string): Promise<void> {
  return deleteRequest(`/api/gmail/accounts/${accountId}`);
}

export function getSkippedEmails(params?: {
  limit?: number;
  offset?: number;
}): Promise<SkippedEmailListResponse> {
  return getData<SkippedEmailListResponse>('/api/gmail/skipped-emails', { params });
}

export function dismissSkippedEmail(recordId: string): Promise<void> {
  return postData<void>(`/api/gmail/skipped-emails/${recordId}/dismiss`);
}

export function analyzeSkippedEmail(recordId: string): Promise<void> {
  return postData<void>(`/api/gmail/skipped-emails/${recordId}/analyze-anyway`);
}

export function tagSkippedEmailSender(sender: string): Promise<TagSkippedEmailSenderResponse> {
  return postData<TagSkippedEmailSenderResponse, { sender: string }>('/api/gmail/skipped-emails/tag-sender', {
    sender,
  });
}
